module.exports = __webpack_public_path__ + "img/yika.c2f41ebb.png";